import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
// import home from '../views/Home.vue'
// import.meta.env.BASE_URL

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
      {
        path: '/',
        name: 'home',
        component: () => import('../views/home.vue'),
      },
      {
        path: '/ainda-nao-sou-cadastrado',
        name: 'ainda-nao-sou-cadastrado',
        component: () => import('../views/ainda-nao-sou-cadastrado.vue'),
      },
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue'),
      },
      {
        path: '/gerenciador',
        name: 'gerenciador',
        component: () => import('../views/gerenciador.vue'),
      },
      {
        path: '/crie-voce-mesmo',
        name: 'crie-voce-mesmo',
        component: () => import('../views/crie-voce-mesmo.vue'),
      },
      {
        path: '/configuracoes-ra',
        name: 'configuracoes-ra',
        component: () => import('../views/configuracoes-ra.vue'),
      },
      {
        path: '/leitor-projeto/:identifier',
        name: 'leitor-projeto',
        component: () => import('../views/leitor-projeto.vue'),
      },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.name === 'login' || to.name === 'home' || to.name === "ainda-nao-sou-cadastrado" || to.name === "leitor-projeto"){
    localStorage.removeItem("token")
    next()
  }else{
    if(!localStorage.getItem("token")){
      next({name: 'home'})
    }else{
      next()
    }
  }
})

export default router